module.exports = __webpack_public_path__ + "static/imageFive-ff2712eca9f533e5f8d1dcf7ea2173dd.jpg";